module.exports = __webpack_public_path__ + "img/phone.8fd884b2.svg";